import { getRequest } from '@/framework/utils/request';
const request = getRequest('common');
const base = '/usercenter'
import axios from 'axios'

// 上传附件
export function uploadFile(data) {
  return request({
    url: base + '/file/upload',
    method: 'post',
    data
  })
}

// 获取文件
export function getFileUrl(data) {
  return request({
    url: base + '/file',
    method: 'get',
    data
  })
}

// 下载文件
export function downloadFileById(id) {
  return request({
    url: base +  '/file/' + id,
    method: 'get',
    responseType: 'blob'
  })
}

// 预览附件
export function getPreviewFile(id) {
  return request({
    url: '/portal/system/previewFile?fileId='+id,
    method: 'get',
  })
}

export function getPreviewFileUrl(id) {
  return request({
    url: base +  '/file/previewFile?fileId='+id,
    method: 'get',
  })
}

// 品类树
export function getCategoryTree(data) {
  return request({
    url: base +  '/category/tree',
    method: 'post',
    data
  })
}

// 组织树
export function getOrgTree(params) {
  return request({
    url: base +  '/org/getTree',
    method: 'get',
    params
  })
}

// 数据字典(单个)
export function getDictList(code) {
  return request({
    url: base +  '/dict/selectDictList',
    method: 'post',
    data: {
      codelist: [code]
    }
  })
}

// 数据字典(多个)
export function getBatchDictList(codelist) {
  return request({
    url: base +  '/dict/selectDictList',
    method: 'post',
    data: {
      codelist
    }
  })
}

// 付款方式
export function getPayMethodList(data) {
  return request({
    url: base +  '/pay-method/custom-page',
    method: 'post',
    data
  })
}

// 付款条件
export function getPayTerms(data) {
  return request({
    url: base +  '/pay-terms/custom-page',
    method: 'post',
    data
  })
}

// 币种
export function getCurrency() {
  return request({
    url: base +  '/currency/page',
    method: 'get',
    params: {
      pageSize: 1000
    }
  })
}

// 物料编码
export function getMaterial(data) {
  return request({
    url: base +  '/material/getMaterialList',
    method: 'post',
    data
  })
}

// 根据名称获取供应商
export function getSupplierListByName(data) {
  return request({
    url: '/supplier/info/getListByName',
    method: 'post',
    data
  })
}

// 供应商大类
export function getBigType() {
  return request({
    url: '/supplier/info/bigType',
    method: 'get'
  })
}

// 供应商小类
export function getSmallType(bigNum) {
  return request({
    url: '/supplier/info/smallType',
    method: 'get',
    params: {
      bigNum
    }
  })
}

// 查询所有一级银行信息
export function getBankList(data) {
  return request({
    url: base +  '/branch-bank/bankList',
    method: 'post',
    data
  })
}

// 根据一级银行编码查询分行列表
export function getSubBankListByNumber(data) {
  return request({
    url: base +  '/branch-bank/list',
    method: 'post',
    data
  })
}

// 查询组织用户
export function getUserListByUserId(data) {
  return request({
    url: `${base}/user/getListByUserOrg`,
    method: 'post',
    data
  })
}

// 查询全部用户组织
export function getOrgListByUserId(userId) {
  return request({
    url: `${base}/user/getOrgListByUserId/${userId}`,
    method: 'get'
  })
}

// 根据用户id查询组织
export function getUserOrgTree(userId) {
  return request({
    url: `${base}/user/getOrgTreeByUserId/${userId}`,
    method: 'get'
  })
}

// 搜索模块-获取片区
export function getOrgCode(params) {
  return request({
    url: `/portal/system/org/getOrgCode`,
    method: 'get',
    params
  })
}


export function sysConfigurationQuery(data) {
  return request({
    url: `${base}/sysConfiguration/queryPage`,
    method: 'post',
    data: data
  })
}

// 获取多语言配置
export function getMultiLanguageConfig(data) {
  return request({
    url: `/portal/system/osMultilingualConfig/page`,
    method: 'post',
    data
  })
}
// 获取多语言配置 缓存
export function getMultiLanguageConfigCache(data) {
  return axios.get(`/srmjson/isp.json`)
  // return request({
  //   url: `/portal/system/osMultilingualConfig/queryFrontendPrompt`,
  //   method: 'get',
  //   params: data
  // })
}

// 更新用户语言配置
export function updateOs(data) {
  return request({
    url: `/portal/supplierAfterLogin/updateOs`,
    method: 'post',
    data
  })
}
